import { Selector } from "@ngxs/store";
import { UpdateRequestInitialState, UpdateRequestState } from "./update-request.state";

export class UpdateRequestSelectors {
    @Selector([UpdateRequestState])
    static updateProOrganizerRequest(state: UpdateRequestInitialState) {
        return state.data;
    }

    @Selector([UpdateRequestState])
    static updateProOrganizerRequestLoading(state: UpdateRequestInitialState) {
        return state.loading;
    }

    @Selector([UpdateRequestState])
    static updateProOrganizerRequestError(state: UpdateRequestInitialState) {
        return state.error;
    }
}